import React, { useEffect, useState } from 'react';
import { Form, Table } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { get_list_of_custom_menu_data } from '../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';
import { Button, Col, Image, Modal, Row } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { errorAlert } from '../../../../function/alert';

const ChooseMenu = ({ formik, expType, count, ...props }) => {
  const [switchMenu, setswitchMenu] = useState(false);
  const handleSwitchMenu = () => setswitchMenu(true);
  const handleCloseSwitchMenu = () => setswitchMenu(false);
  const [customMenuList, setCustomMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState({});

  useEffect(() => {
    if (props.serviceType.vendor_id) {
      props.get_list_of_custom_menu_data(props?.serviceType?.vendor_id);
    }
  }, [props?.serviceType]);

  useEffect(() => {
    if (props.customMenuList) {
      const updatedList = [...props.customMenuList];
      setCustomMenuList(updatedList);
    }
  }, [props.customMenuList]);

  const HandleMenuSelection = (item) => {
    setSelectedMenu(item);
  };

  const ChooseMenuForExp = (item) => {
    if (item) {
      const menuArr = formik.values.menuList || []; // Ensure menuArr is an array
      const menuExists = menuArr.some((menu) => menu._id === item._id);
      if (menuExists) {
        errorAlert('Menu already exists');
      } else {
        const updatedMenuArr = [...menuArr, item];
        formik.setFieldValue('menuList', updatedMenuArr);
        handleCloseSwitchMenu();
      }
    }
  };

  const removeMenu = (menuId) => {
    const updatedMenuArr = formik.values.menuList.filter(
      (menu) => menu._id !== menuId
    );
    formik.setFieldValue('menuList', updatedMenuArr);
  };

  return (
    <>
      <Form>
        <div className="f20-700 text-dark mt-4 mb-5">Choose Menu</div>
        <div
          className="d-flex justify-content-between p-2"
          style={{ backgroundColor: '#80808054', borderRadius: '8px' }}
        >
          <div className="f14-7500">Menu Setup</div>
          <div
            className="f14-500 p-1"
            style={{
              border: '1px solid #ee3a23',
              borderRadius: '4px',
              backgroundColor: '#ffc0c05e',
            }}
            onClick={() => handleSwitchMenu()}
          >
            + Add Menu
          </div>
        </div>
        <Row>
          <Col md={8}>
            {formik.values.menuList && formik.values.menuList.length > 0 ? (
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr>
                    <th>Set Default</th>
                    <th>Menu Name</th>
                    <th>Description</th>
                    <th>More Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {formik.values.menuList.map((menu, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Check
                          type="radio"
                          name="defaultMenu"
                          id={`defaultMenu-${index}`}
                        />
                      </td>
                      <td>{menu.name}</td>
                      <td>{menu.description}</td>
                      <td>
                        {/* Add any actions you want to provide */}
                        <div
                          className="enIconBtn mr-3"
                          onClick={() => {
                            removeMenu(menu._id);
                          }}
                        >
                          <Image
                            src={require('../../../../assets/images/UserManagement/delete-gray.svg')}
                            alt="delete"
                            title="delete"
                            fluid
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="mt-3 text-center">
                No menus have been added yet.
              </div>
            )}
          </Col>
        </Row>
      </Form>
      <Modal
        show={switchMenu}
        onHide={handleCloseSwitchMenu}
        centered
        className="xl-width-750 selectCatalogueModal"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f20-700 pt-2">Select Menu</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="d-flex mobileColumn justify-content-between mx-4 mb-3">
            <p className="f14-400 ml-4">Menu Name</p>
            <p className="f14-400">Menu Description</p>
          </div>
          <div className="enGlobleCatelogueModalListMain">
            <Scrollbars style={{ width: '100%', height: 280 }}>
              {customMenuList
                ?.filter((i) => i.menuType === 'CUSTOM')
                .map((item, index) => (
                  <div className="d-flex align-items-center mb-4" key={index}>
                    {/* <Form.Check label="1" inline className="enCheckBoxOnly" /> */}
                    <label className="enRadioWithText small">
                      <input
                        type="radio"
                        name="ItemCode"
                        // checked={
                        //   activeMenu?._id === item._id ||
                        //   (activeMenu == null && item._id === '123456')
                        // }
                        onClick={() => HandleMenuSelection(item)}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <div className="border p-2 d-flex align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center">
                        {/* <div className="enCatelogueIconDiv">
                            <SVG
                              width="27px"
                              src={require('../../../../../../../assets/images/UserManagement/menuicon.svg')}
                            />
                          </div> */}
                        <div className="f14-500 px-3">{item?.name}</div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f14-500 pr-3">{item?.description}</div>
                      </div>
                    </div>
                  </div>
                ))}
            </Scrollbars>
          </div>
          <div className="d-flex mobile-center align-items-center py-4">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
              onClick={handleCloseSwitchMenu}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn150px btn-lg px-5"
              disabled={!selectedMenu}
              onClick={() => ChooseMenuForExp(selectedMenu)}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

ChooseMenu.propTypes = {
  auth: PropTypes.object.isRequired,
  customMenuList: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  serviceType:
    state.onboarding && state.onboarding?.onboard_subscription_details,
  customMenuList: state?.onboarding?.get_custom_menu_list,
});

export default connect(mapStateToProps, {
  get_list_of_custom_menu_data,
})(ChooseMenu);
